import { SplitFees } from './SplitFees'
import SplitFeesPopupProvider from './Providers/SplitFeesPopupProvider'

export const SplitFeesContainer = () => {
  return (
    <SplitFeesPopupProvider>
      <SplitFees />
    </SplitFeesPopupProvider>
  )
}
